import { IApi } from '../api'
import { runDetached } from '../helpers/redux'
import { updateAdjustmentSuccess } from './adjustment/sagas'
import {
  feedArcPresence,
  refetchOnArcWrite,
  refreshAutomationsAfterMutation,
  refreshDocsAfterMutation,
  refreshMemoriesAfterMutation,
  refreshPromptsAfterMutation,
  watchOrphanedSubagentPanel,
} from './atlasai/sagas'
import { exportAuditLog } from './auditLog/sagas'
import { exportBankTransactions } from './bankTransactions/sagas'
import {
  bbcUpdateSuccess,
  bbcFilesSubmitSuccess,
  recalculateClientCollateral,
  refetchBBCReserves,
  refetchCustomRules,
  refetchCustomRulesLabels,
  calculateClientCollateralSuccess,
  downloadBBCExport,
  downloadTemplate,
  exportARRollforward,
  exportAPRollforward,
  bbcFlagUpdate,
} from './bbc/sagas'
import {
  updateSuccess as updateClientInfoSuccess,
  exportClientAccountActivity,
  exportClientFeeStatement,
  exportArEligibility,
  loadOveradvances,
  createRequireReportSuccess,
  repullClientInfo,
  terminateSuccess,
  exportPortfolioReview,
  exportTermLoansAndOveradvances,
  exportRiskRatingSummary,
  exportMasterInventory,
} from './clientInfo/sagas'
import { clientIntakeRedirect } from './clientIntake/sagas'
import {
  uploadChecksSuccess,
  addCheckAccountSuccess,
  submitCollectionSuccess,
  exportAggregation,
  pullMidDayTotals,
  repullWiresFilesAndStatus,
  refreshWiresAfterDelete,
  repullChecksInfo,
  uploadWireSuccess,
  updateMidDayWireSuccess,
} from './collections/sagas'
import {
  refreshData as refreshDueDiligenceData,
  refreshDocuments as refreshDueDiligenceDocuments,
  processDocumentsSuccess as processDueDiligenceDocumentsSuccess,
  profileSuccess as profileDueDiligenceDocumentsSuccess,
  documentRequestUploadSuccess as dueDiligenceDocumentRequestUploadSuccess,
  updateTeamMemberSuccess as dueDiligenceUpdateTeamMemberSuccess,
  getDocumentRequestsSharedLink as dueDiligenceGetDocumentRequestsSharedLink,
  runBBCSuccess as dueDiligenceRunBBCSuccess,
  updateDueDiligenceInfo as dueDiligenceUpdateInfo,
} from './dueDiligence/sagas'
import {
  exportCustomerAggregation,
  exportVendorAggregation,
  exportInvestorSummary,
  addEntitySuccess,
  updateEntityInfoSuccess,
} from './entityInfo/sagas'
import { updateFeeSuccess } from './fee/sagas'
import { repullNewFlagCount, refetchFlagsOnArcComplete } from './flag/sagas'
import { refreshEventsOnMutation, refreshCommentaryOnArcComplete } from './generalAnalysis/sagas'
import { refreshOngoingReporting } from './generalLedger/sagas'
import { feedHuddles } from './huddles/sagas'
import {
  exportLoanBalanceTransactions,
  downloadAverageLoanBalanceResult,
  exportEndOfMonthFlow,
  reloadLatestEndOfMonthFlow,
  exportIneligibles,
} from './loanBalance/sagas'
import { exportNewsfeed, refreshHeadlineAfterReply } from './newsfeed/sagas'
import { exportNotes, refetchNotesOnArcComplete, refreshNotesCountOnRead } from './notes/sagas'
import {
  updateOngoingReportingSuccess,
  exportSalesBySkuVisualization,
} from './ongoingReporting/sagas'
import { exportParticipationActivity } from './participant/sagas'
import {
  loginSuccess,
  loginFailure,
  logoutSuccess,
  profileSuccess,
  permissionDenied,
  loginAsClientSuccess,
  switchContextSuccess,
  logoutAsClientSuccess,
  googleAuthLinking,
  verify2FASuccess,
  toggleSidebarPersist,
} from './profile/sagas'
import {
  createSuccess as createProspectSuccess,
  createProspectTermSuccess,
  deleteProspectSuccess,
  generateTermSheetSuccess,
  updateOPSReporting,
  refreshOpsFlags,
  submitOPSSuccess,
} from './prospect/sagas'
import { exportQboReports } from './qbo/sagas'
import { exportReportSuccess } from './reports/sagas'
import { refetchMessagesOnInbound } from './twilio/sagas'
import { notify } from './ui/sagas'
import { listFailure } from './user/sagas'

export default function* rootSaga(api: IApi) {
  yield* runDetached([
    loginSuccess(api),
    loginFailure(),
    logoutSuccess(api),
    googleAuthLinking(),
    verify2FASuccess(api),
    profileSuccess(),
    permissionDenied(),
    toggleSidebarPersist(),
    listFailure(),
    updateClientInfoSuccess(),
    exportClientAccountActivity(),
    exportClientFeeStatement(),
    exportIneligibles(),
    downloadTemplate(),
    loadOveradvances(),
    createRequireReportSuccess(),
    repullClientInfo(),
    terminateSuccess(),
    uploadChecksSuccess(),
    addCheckAccountSuccess(),
    submitCollectionSuccess(),
    exportAggregation(),
    updateFeeSuccess(),
    updateAdjustmentSuccess(),
    exportLoanBalanceTransactions(),
    downloadAverageLoanBalanceResult(),
    exportEndOfMonthFlow(),
    reloadLatestEndOfMonthFlow(),
    bbcUpdateSuccess(),
    bbcFilesSubmitSuccess(),
    bbcFlagUpdate(),
    recalculateClientCollateral(),
    refetchBBCReserves(),
    refetchCustomRules(),
    refetchCustomRulesLabels(),
    calculateClientCollateralSuccess(),
    downloadBBCExport(),
    exportAuditLog(api),
    refreshEventsOnMutation(),
    refreshCommentaryOnArcComplete(),
    notify(),
    updateOngoingReportingSuccess(),
    createProspectSuccess(),
    submitOPSSuccess(),
    exportARRollforward(),
    exportAPRollforward(),
    refreshOngoingReporting(),
    addEntitySuccess(),
    pullMidDayTotals(),
    repullWiresFilesAndStatus(),
    refreshWiresAfterDelete(),
    updateEntityInfoSuccess(),
    exportPortfolioReview(api),
    exportTermLoansAndOveradvances(api),
    exportCustomerAggregation(),
    exportReportSuccess(),
    exportVendorAggregation(),
    exportInvestorSummary(),
    refreshDueDiligenceData(),
    refreshDueDiligenceDocuments(),
    processDueDiligenceDocumentsSuccess(),
    profileDueDiligenceDocumentsSuccess(),
    dueDiligenceDocumentRequestUploadSuccess(),
    dueDiligenceUpdateTeamMemberSuccess(),
    dueDiligenceGetDocumentRequestsSharedLink(),
    dueDiligenceRunBBCSuccess(),
    dueDiligenceUpdateInfo(),
    createProspectTermSuccess(),
    deleteProspectSuccess(),
    clientIntakeRedirect(),
    generateTermSheetSuccess(),
    updateOPSReporting(),
    exportRiskRatingSummary(),
    exportSalesBySkuVisualization(),
    exportNotes(),
    refetchNotesOnArcComplete(),
    refreshNotesCountOnRead(),
    exportParticipationActivity(),
    exportQboReports(),
    loginAsClientSuccess(api),
    switchContextSuccess(api),
    logoutAsClientSuccess(api),
    exportMasterInventory(),
    refreshOpsFlags(),
    repullNewFlagCount(),
    refetchFlagsOnArcComplete(),
    exportBankTransactions(),
    repullChecksInfo(),
    exportNewsfeed(),
    refreshHeadlineAfterReply(),
    uploadWireSuccess(),
    updateMidDayWireSuccess(),
    exportArEligibility(),
    watchOrphanedSubagentPanel(),
    refetchOnArcWrite(),
    feedArcPresence(),
    feedHuddles(),
    refreshDocsAfterMutation(),
    refreshMemoriesAfterMutation(),
    refreshPromptsAfterMutation(),
    refreshAutomationsAfterMutation(),
    refetchMessagesOnInbound(),
  ])
}
